import React from 'react';

export function DateSpan({dateFmt, value}) {
  return <span>{value && dateFmt.format(new Date(value))}</span>
}